import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Alignment, Answer } from '@digilize/shared/definitions/src';
import { getFirstControlWithError } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-multi-answer-tiles',
  templateUrl: './multi-answer-tiles.component.html',
  styleUrls: ['./multi-answer-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiAnswerTilesComponent implements OnInit {
  @Input() formGroup: FormGroup = new FormGroup({
    mockControl1: new FormControl(),
    mockControl2: new FormControl(),
  });
  @Input() answers: Answer[];
  @Input() multipleCols = true;
  @Input() sameHeightElements = false; /* single col support only */
  @Input() withInnerHTML = false;
  @Input() align: Alignment = 'left';
  @Input() othersFg: FormGroup = new FormGroup({
    mockControl1: new FormControl(null, Validators.required),
  });
  @Output() changed = new EventEmitter<string[]>();
  @ViewChildren('otherInput')
  private otherInputs: QueryList<ElementRef<HTMLInputElement>>;
  atLeastOneOther = false;
  public getFirstControlWithError = getFirstControlWithError;
  constructor() {}

  ngOnInit(): void {
    this.atLeastOneOther = !!this.answers.find((answer) => answer.is_other);
  }

  initOthers() {}
  focusOther(value: any) {
    setTimeout(() => {
      Array.from(this.otherInputs)
        .find((input) => {
          return input.nativeElement.id === `other${value}`;
        })
        ?.nativeElement.focus();
    });
  }
  validate() {
    setTimeout(() => {
      this.formGroup.markAllAsTouched();
    }, 0);
  }
}
